import {CommandBase} from './command-base';

export class QueryConnectionsCommand extends CommandBase {
  constructor() {
    super('QueryConnectionsCommand');
  }
}
